import React, { useEffect } from 'react';
import type { MergePair } from '../types';
import MergePairComponent from './MergePair';
import MergeInlineNotice from './MergeInlineNotice';
import { useMergeActions } from './useMergeActions';
import { approveAllEventName, dismissAllEventName } from '../archive/constants';

interface Props {
  pairs: MergePair[];
}

export default function MergeBody({ pairs }: Props): React.ReactElement {
  const { decoratedPairs, notice, merge, dismiss, swap, undo, mergeAll, dismissAll } =
    useMergeActions(pairs);

  useEffect(() => {
    const approveHandler = () => mergeAll();
    const dismissHandler = () => dismissAll();
    const approveEvent = approveAllEventName('merge');
    const dismissEvent = dismissAllEventName('merge');
    window.addEventListener(approveEvent, approveHandler);
    window.addEventListener(dismissEvent, dismissHandler);
    return () => {
      window.removeEventListener(approveEvent, approveHandler);
      window.removeEventListener(dismissEvent, dismissHandler);
    };
  }, [mergeAll, dismissAll]);

  return (
    <>
      {notice && <MergeInlineNotice notice={notice} onUndo={undo} />}
      {decoratedPairs.length === 0 ? (
        <div className="mt-5 bg-white border border-lineSoft rounded-lg px-6 py-12 text-center text-helper text-small">
          All suggestions reviewed. Nothing left to merge right now.
        </div>
      ) : (
        <div className="mt-5">
          {decoratedPairs.map((pair) => (
            <MergePairComponent
              key={pair.id}
              pair={pair}
              onMerge={() => merge(pair.id)}
              onDismiss={() => dismiss(pair.id)}
              onSwap={() => swap(pair.id)}
            />
          ))}
          <div className="border-b border-lineSoft" />
        </div>
      )}
    </>
  );
}